<template>
  <MonitorWrapper>
    <div class="cd603-container">
      <template v-if="!empty">
        <StatusBar v-bind="status" />
        <ChartWrap ref="chartWrap" :datas="charts" />
      </template>

      <template v-else>
        <div class="hint">{{ isHisDetail ? '暂无数据' : '数据加载中...' }}</div>
      </template>
    </div>
  </MonitorWrapper>
</template>

<script>
import StatusBar from './components/status-bar.vue';
import ChartWrap from './components/wrap.vue';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';

import { isEmpty, isObject } from '@/utils/is';

import { makeData } from './utils/faker';

export default {
  name: 'CD603',
  mixins: [singleDeviceMixin],
  components: {
    StatusBar,
    ChartWrap
  },
  sockets: {
    '/socket/detail'(res) {
      if (!res || res.sn !== this.sn) return;
      this.update(res);
    }
  },
  provide() {
    return {
      time: this.time
    };
  },
  data() {
    return {
      status: {
        alarmStatus: -1,
        runState: 0,
        pumpStatus: {
          install: 0,
          run: 0
        },
        humidity: 0,
        temperature: 0,
        absoluteHumidity: 0,
        atmosphericPressure: 0
      },
      charts: [],
      time: {},
      empty: false
    };
  },
  methods: {
    getDetail() {
      this.getHistoryDetailData(this.eventId)
        .then(res => {
          if (!isObject(res) || !isObject(res.data)) return;

          const { deviceData, deviceDatas } = res.data;

          if (!Array.isArray(deviceDatas)) return;

          this.setData(deviceData);

          let mod = null;

          let isNonSensors = 0;

          const list = deviceDatas
            .map(e => {
              mod = this.getCD603Mod(e);

              if (!mod) return;

              // 统计无传感器数据条数
              if (isEmpty(mod.sensors)) isNonSensors++;

              return { sensors: mod.sensors || [], beginTime: e.beginTime };
            })
            .filter(e => isObject(e));

          // 数据无传感器信息提示
          if (isNonSensors >= list.length) {
            this.$message.warning(this.translateTo('未获取到传感器信息', 'query'));
          }

          this.$refs.chartWrap.setData(list, this.getCD603Mod(deviceData));
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    getCD603Mod(res) {
      if (!res || !res.mods || !res.mods.cd603Mod) return null;
      return res.mods.cd603Mod;
    },
    setData(res) {
      try {
        const { status, charts } = this;
        const { pumpStatus } = status;
        const { runstate, state, mods, beginTime } = res;
        const { cd603Mod } = mods;

        if (isEmpty(cd603Mod?.sensors)) return;
        if (charts.length !== 0 && charts.length > cd603Mod.sensors.length) return;

        this.time.begin = beginTime;
        Object.assign(status, {
          runState: runstate,
          alarmStatus: state,
          humidity: cd603Mod.humidity,
          temperature: cd603Mod.temp,
          absoluteHumidity: cd603Mod.absoluteHumidity,
          atmosphericPressure: cd603Mod.atmosphericPressure
        });
        Object.assign(pumpStatus, {
          run: cd603Mod.pumpRunstate,
          install: cd603Mod.pumpInstallState
        });
        charts.splice(0, Infinity, ...cd603Mod.sensors);
        this.empty = false;
      } catch (err) {
        console.error('[CD603][MONITRO][update error]', err);
      }
    },
    update(res) {
      if (!this.isHisDetail) this.setData(res);
    },
    enableMock() {
      let num = 1;
      this.mockTimer = setInterval(() => {
        this.update(makeData(num++));
      }, 2000);
    }
  },
  mounted() {
    // this.enableMock();

    if (!this.isHisDetail) return;
    this.$nextTick(() => {
      this.getDetail();
    });
  },
  beforeDestroy() {
    clearInterval(this.mockTimer);
  }
};
</script>

<style lang="scss">
.cd603-container {
  width: 100%;
  height: 100%;

  span {
    @include state-textstyle;
  }

  .hint {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .common-border2 {
    border: 1px solid rgb(96, 118, 173);
  }

  .common-border {
    height: 100%;
    padding: 2px;
    background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
      url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
      url('~@/assets/image/linelight.png');
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: top left, top right, bottom left, bottom right, center -5px;

    .comp3-content {
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
